import React, { memo } from "react";

export default memo(() => {
    return (<br />)
});


// WEBPACK FOOTER //
// ./src/components/ui-ant/Space/index.js